/**
 * Strip HTML down to plain text for the "is this template empty" check
 * (create-dialog) and the list-page preview snippet — previously copied
 * byte-for-byte in both files (see M-029).
 */
export const stripTags = (html) => html
    .replace(/<\s*br\s*\/?\s*>/gi, ' ')
    .replace(/<[^>]+>/g, '')
    .replace(/\s+/g, ' ')
    .trim();
//# sourceMappingURL=lib.js.map